import { useEffect } from "react";

export default function useDialogViewport() {
    useEffect(() => {
        const viewport = window.visualViewport;
        const root = document.documentElement;
        const names = ["--soma-viewport-height", "--soma-viewport-top"];
        const previous = names.map((name) => root.style.getPropertyValue(name));
        let frame;

        const sync = () => {
            root.style.setProperty(names[0], `${viewport?.height || window.innerHeight}px`);
            root.style.setProperty(names[1], `${viewport?.offsetTop || 0}px`);
        };
        const resize = () => {
            sync();
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                const active = document.activeElement;
                if (!active?.matches("input, select, textarea")) return;
                const body = active.closest(".modal.show .modal-body, .mail-modal-card");
                if (!body) return;
                const bounds = body.getBoundingClientRect();
                const field = active.getBoundingClientRect();
                if (field.top < bounds.top || field.bottom > bounds.bottom) {
                    active.scrollIntoView({ block: "nearest", inline: "nearest" });
                }
            });
        };

        sync();
        window.addEventListener("resize", resize);
        viewport?.addEventListener("resize", resize);
        viewport?.addEventListener("scroll", sync);
        return () => {
            cancelAnimationFrame(frame);
            window.removeEventListener("resize", resize);
            viewport?.removeEventListener("resize", resize);
            viewport?.removeEventListener("scroll", sync);
            names.forEach((name, index) => {
                if (previous[index]) root.style.setProperty(name, previous[index]);
                else root.style.removeProperty(name);
            });
        };
    }, []);
}
